<template>
  <div class="banner">
    <img :src="leaveImg" alt="" class="endBtn" @mouseenter="leaveBtnActive" @mouseleave="leaveBtn" />
    <img :src="restImg" alt="" class="replayBtn" @click="replay" @mouseenter="restBtnActive" @mouseleave="restBtn" />
  </div>
</template>
<script setup>
import router from "@/router";

import leave from "../assets/img/end/leave.png";
import leaveActive from "../assets/img/end/leaveActive.png";

import rest from "../assets/img/end/rest.png";
import restActive from "../assets/img/end/restActive.png";
import { ref } from "vue";

// 高亮切换
let leaveImg = ref(leave);
let restImg = ref(rest);
// 首页按钮切换
const leaveBtnActive = () => {
  leaveImg.value = leaveActive;
};
const leaveBtn = () => {
  leaveImg.value = leave;
};
// 首页按钮切换
const restBtnActive = () => {
  restImg.value = restActive;
};
const restBtn = () => {
  restImg.value = rest;
};

const replay = () => {
  router.push({ name: "home" });
};
</script>
<style lang="scss" scoped>
.banner {
  width: 100vw;
  height: 100vh;
  background-image: url(../assets/img/double/background.png);
  background-size: 100% 100%;
  position: relative;
  .endBtn {
    width: 19.5vw;
    position: absolute;
    top: 44vh;
    left: 26vw;
  }
  .replayBtn {
    width: 19.5vw;
    position: absolute;
    top: 44vh;
    left: 55vw;
  }
}
</style>
